import { useTranslation } from 'react-i18next';

import ThemedPageHeader from '~/components/PageHeader/ThemedPageHeader';

import Reward from './Reward';

const RewardsProgress = ({ rewards }: any) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4 flex w-full items-center justify-between border-b border-gray-300 pb-8">
      <div className="w-full space-y-4">
        <ThemedPageHeader title={t('referrals.reward.progress.title')} description={t('referrals.description')} />
        <div className="space-y-8">
          {rewards.map((reward: any) => {
            return (
              <Reward
                key={reward.id}
                name={reward.name}
                description={reward.description}
                disclaimer={reward.disclaimer}
                prefixedArticle={reward.prefixed_article}
                image={reward.image.thumb.url}
                isAchieved={reward.is_achieved}
                numerator={reward.num_referrals - reward.num_referrals_until}
                denominator={reward.num_referrals}
                showProgress
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RewardsProgress;
